import { render } from "./ViewChallengeResults.vue?vue&type=template&id=b1f4d4be&scoped=true"
import script from "./ViewChallengeResults.vue?vue&type=script&lang=js"
export * from "./ViewChallengeResults.vue?vue&type=script&lang=js"

import "@/css/views/view-challenge-results.css?vue&type=style&index=0&id=b1f4d4be&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f4d4be"]])

export default __exports__